// extracted by mini-css-extract-plugin
module.exports = {"main":"resolution-filter_main__XtVX1","optionRow":"resolution-filter_optionRow__lBb04"};